var getters = {
  token: function token(state) {
    return state.user.token;
  },
  CMToken: function CMToken(state) {
    return state.user.CMToken;
  },
  userInfo: function userInfo(state) {
    return state.user;
  },
  dic: function dic(state) {
    return state.dic;
  },
  operateCodes: function operateCodes(state) {
    return state.user.operateCodes;
  },
  tribunalType: function tribunalType(state) {
    return state.commonInfo.tribunalType;
  },
  showNameMap: function showNameMap(state) {
    return state.commonInfo.showNameMap;
  },
  maxFileSize: function maxFileSize(state) {
    return state.commonInfo.maxFileSize;
  },
  skin: function skin(state) {
    if (sessionStorage.getItem('Hikkan-Skin')) {
      state.skin = sessionStorage.getItem('Hikkan-Skin');
    }

    return state.skin;
  }
};
export default getters;